<template>
  <div class="campaign_add_edit_dialog">
    <el-dialog custom-class="with-title" :title="title" :visible="visible" @close="close">
      <twitter-instantwin-add-edit
        v-if="tab === 'twitter-instantwin-campaign'"
        :mode="mode"
        :campaignId="campaignId"
        :isCopy="isCopy"
        :isChangeWithoutSubmit.sync="isChangeWithoutSubmit"
        @actionSuccess="savedCampaign"
      ></twitter-instantwin-add-edit>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TwitterInstantwinAddEdit from '@/client/features/campaigns/components/twitter_instantwin_add_edit'
import { TrackingService } from '@/client/services'

export default defineComponent({
  components: {
    TwitterInstantwinAddEdit
  },

  data() {
    return {
      tab: '',
      mode: 'add',
      title: '',
      // 子の campaignId prop は Number なので、未指定は null ではなく undefined で持つ
      campaignId: undefined as number | undefined,
      isCopy: false,
      visible: false,
      isChangeWithoutSubmit: false
    }
  },

  methods: {
    /**
     * ダイアログを開く
     * @param {string} type タイプ 'add' | 'edit'
     * @param {number | null} campaignId キャンペーンID（新規作成時は null）
     * @param {boolean} isCopy
     */
    open(type: string, campaignId: number | null, campaignType: string, isCopy = false) {
      switch (type) {
        case 'addTwitter':
          this.tab = 'twitter-instantwin-campaign'
          this.title = 'キャンペーンの新規作成(インスタントウィン)'
          this.mode = 'add'
          break
        case 'editTwitter':
          this.tab = 'twitter-instantwin-campaign'
          this.title = 'キャンペーンの編集(インスタントウィン)'
          this.mode = 'edit'
          break
        case 'copyTwitter':
          this.tab = 'twitter-instantwin-campaign'
          this.title = 'キャンペーンの新規作成(インスタントウィン)'
          this.mode = 'add'
          break
      }

      this.visible = true
      this.campaignId = campaignId ?? undefined
      this.isCopy = isCopy
    },

    /**
     * キャンペーンを保存してダイアログを閉じる
     * @returns {void} void
     */
    savedCampaign(): void {
      this.$emit('actionSuccess')
      this.$nextTick(() => {
        this.close(true)
      })
    },

    /**
     * ダイアログを閉じる
     * @param {boolean} isSubmit
     * @returns {void} void
     */
    close(isSubmit = false): void {
      TrackingService.sendEvent('click:キャンペーンの新規作成(IW)|閉じる')

      if (this.tab === 'twitter-instantwin-campaign' && this.isChangeWithoutSubmit && !isSubmit) {
        const message = '編集内容が保存されていません。ダイアログを閉じてよろしいですか?'
        const confirm = window.confirm(message)

        if (!confirm) {
          return
        }
      }

      this.visible = false
      this.tab = ''
    }
  }
})
</script>
